import { Skeleton, Stack, Box } from '@mui/material'

const CardSkeleton = () => {
  return (
    <Stack spacing={2} sx={{ width: '100%', minWidth: '350px', px: 2 }}>
      <Stack spacing={1} alignItems={'center'}>
        <Skeleton width={120} height={24} sx={{ bgcolor: '#EFEFEF' }} />
        <Skeleton width={200} height={24} sx={{ bgcolor: '#EFEFEF' }} />
      </Stack>

      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, py: 3 }}>
        {[1, 2, 3].map((i) => (
          <Skeleton 
            key={i} 
            width={32} 
            height={32} 
            variant="rectangular" 
            sx={{ borderRadius: '8px', bgcolor: '#EFEFEF' }} 
          />
        ))}
      </Box>

      <Stack spacing={2} sx={{ height: 'calc(100vh - 400px)', overflow: 'auto' }}>
        {[1, 2, 3].map((i) => (
          <Box key={i} sx={{ p: 2, border: '1px solid #E5E7EB', borderRadius: '16px' }}>
            <Stack spacing={1}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Skeleton width={80} height={20} sx={{ bgcolor: '#EFEFEF' }} />
                <Skeleton width={100} height={24} sx={{ bgcolor: '#EFEFEF' }} />
              </Box>
              <Skeleton width={140} height={20} sx={{ bgcolor: '#EFEFEF' }} />
              <Skeleton width={120} height={20} sx={{ bgcolor: '#EFEFEF' }} />
            </Stack>
          </Box>
        ))}
      </Stack>
    </Stack>
  )
}

export default CardSkeleton
